<template>
  <div>
    <div v-if="!shipments || shipments.length <= 0">--</div>
    <div v-for="(item,index) in shipments" v-else :key="index">
      <button :class="getStyle(item)" :disabled="getButtonDisable(item)" @dblclick.stop="handleClick(item)">
        {{ getStatusText(item) }}
      </button>
    </div>

    <!-- 状态修改弹窗 -->
    <material-dialog :width="500" :visible="showDialog" :title="$t('Views.Order.sure')" @cancleFn="handleDialogCancle" @confirmFn="handleDialogConfirm">
      <template>
        {{ sureStatus }}
        <div class="tips-yoyo">
          {{ sureTips }}
        </div>
        <v-form v-if="showDateTime" ref="countForm">
          <div class="detailWrap input-required">
            <label for="">{{ $t('Views.Order.ship_time_label') }}</label>
            ：
          </div>
          <v-layout row>
            <v-flex>
              <material-dateTime
                v-model="shippedTime"
                :clearable="false"
                class=" margin-left-20 width-250"
                display-format="YYYY-MM-DD"
                type="date"
                no-title
                :rules="[this.$util.rules.emptyRule($t('Views.Order.shipmentDate'))]"
                label=""
                :placeholder="$t('Views.Customer.selectSignDate')"
                :min-date="new Date().toDateString()"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </template>
    </material-dialog>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapActions } from 'vuex'

export default {
  props: {
    shipments: {
      type: Array,
      default: () => { return [] }
    },
    type: {
      type: String,
      default: 'sale' // yayoi 弥生记上 sale 销售记上
    }
  },
  data() {
    return {
      showDialog: false,
      sureTips: '',
      sureStatus: '',
      showDateTime: false,
      shippedTime: '',
      currentId: ''
    }
  },
  methods: {
    ...mapActions('order', ['toggleYayoiCounted', 'togglSalesCounted']),
    getButtonDisable(item) {
      return (this.type === 'yayoi' ? item.yayoiCounted : item.salesCounted)
    },
    getStatusText(item) {
      return (this.type === 'yayoi' ? item.yayoiCounted : item.salesCounted) ? this.$t('Views.Order.hasCopyed') : this.$t('Views.Order.withoutCopyed')
    },
    getStyle(item) {
      return (this.type === 'yayoi' ? item.yayoiCounted : item.salesCounted) ? ['jishang'] : ['weijishang']
    },
    get_next_weekday(date) {
      // 取明天（工作日）
      var tomorrow = new Date(date.setDate(date.getDate() + 1))
      return tomorrow.getDay() % 6 ? format(tomorrow, 'YYYY-MM-DD') : this.get_next_weekday(tomorrow)
    },
    handleClick(item) {
      this.$refs.countForm && this.$refs.countForm.resetValidation()
      this.shippedTime = this.get_next_weekday(new Date())
      this.currentId = item.shipmentId

      switch (this.type) {
        case 'yayoi':
          this.sureStatus = this.$t('Views.Order.sureYayoiCounted', { '0': item.number })
          this.sureTips = ''
          this.showDateTime = true
          break
        case 'sale':
          this.sureStatus = this.$t('Views.Order.sureSalesStatus', { '0': item.number })
          this.sureTips = ''
          this.showDateTime = false
          break
        default:
          break
      }
      this.showDialog = true
    },
    handleDialogCancle() {
      this.showDialog = false
    },
    handleDialogConfirm() {
      switch (this.type) {
        case 'yayoi':
          if (this.$refs.countForm.validate()) {
            this.toggleYayoiCounted({
              id: this.currentId,
              shippedTime: this.shippedTime
            }).then(() => {
              this.$emit('handleReloadList')
              this.showDialog = false
            })
          }
          break
        case 'sale':
          this.togglSalesCounted(this.currentId).then(() => {
            this.$emit('handleReloadList')
            this.showDialog = false
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
